// the general date of the website
export const company_name = "Light Dent";
export const short_name = "light";
export const contact_mail = "contact@lightdent.io";
export const privacy_mail = "privacy@lightdent.io";
export const location = "Kurdistan Region, Iraq";
export const developer_mail = "developer@lightdent.io";
export const update_date = "May 8, 2026";

// the payment of the application
export const dashboard_cost = 99;
export const dental_cost = 69;
export const all_cost = dashboard_cost + dental_cost;

// the token
export const token = "$/light/$";